import * as tokens from '@utmost.co/utmost-design-tokens';
import { Components } from '../../../styles';
import { COLOR_DEFAULT, COLOR_PRIMARY, COLOR_SECONDARY } from './button';

export const radioTheme = {
  MuiRadio: {
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          color: tokens.stateOnSurfaceDisabledContentStateLayerColor
        },
        variants: [
          {
            props: { color: 'primary' },
            style: {
              '&.Mui-checked': {
                color: COLOR_PRIMARY.contained.backgroundColor
              }
            }
          },
          {
            props: { color: 'default' },
            style: {
              '&.Mui-checked': {
                color: COLOR_DEFAULT.contained.color
              }
            }
          },
          {
            props: { color: 'secondary' },
            style: {
              '&.Mui-checked': {
                color: COLOR_SECONDARY.contained.backgroundColor
              }
            }
          }
        ]
      }
    }
  }
} satisfies Components;
